'use client'

import Heading from '@/components/Heading/Heading'

export default function Home() {
  return (
    <div className="flex w-full bg-white gap-[32px]">
      <div className="flex-grow">
        <Heading
          title={'Settings'}
          description={'Configure application settings.'}
        />
      </div>
    </div>
  )
}
